var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPodcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.5v5a5 5 0 01-10 0v-5a5 5 0 0110 0zM4 9v1.5a8 8 0 0016 0V9m-8 9.5v3m-6 0h12",
    fill: "none",
    stroke: "#000450"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iUG9kY2FzdCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggaWQ9Ikljb24iIGQ9Ik0xNyw1LjV2NWE1LDUsMCwwLDEtMTAsMHYtNWE1LDUsMCwwLDEsMTAsMFpNNCw5djEuNWE4LDgsMCwwLDAsMTYsMFY5bS04LDkuNXYzbS02LDBIMTgiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMDQ1MCIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgPHJlY3QgaWQ9IkNvbnRhaW5lciIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJub25lIi8+Cjwvc3ZnPgo=";
export { SvgPodcast as ReactComponent };